import React from "react";
import { Switch, withStyles } from "@material-ui/core";

export function Cell(props) {
  return (
    <div className="row m-0 w-100 ">
      <div
        className={`list-body col-12 col-lg px-0 ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        <div style={{ paddingTop: "12px", paddingBottom: "12px" }} className={`row m-0 ps-2`}>
          {props.children}
        </div>
      </div>
    </div>
  );
}

export function CellItem(props) {
  return (
    <>
      <div
        className={`d-flex align-items-center px-0 px-lg-auto pt-2 pt-lg-0 col-${
          props.size === undefined ? "12" : props.size
        } col-lg-${props.sizeLg}  ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        <div className="row m-0">
          <span className=" ff-univanova-bold fz-14 text-cl-black">{props.title}</span>
          <span className=" ff-univanova-regular fz-14 text-cl-black">{props.value}</span>
        </div>
      </div>
    </>
  );
}

export function CellItemLink(props) {
  return (
    <>
      <div
        className={`d-flex align-items-center col-${props.size === undefined ? "12" : props.size} col-lg-${
          props.sizeLg
        } ${(props.className !== undefined) & (props.className !== null) ? props.className : ""}`}
      >
        <div className="row m-0">
          <span className=" ff-univanova-bold fz-14 text-cl-black">{props.title}</span>
          <a href={props.link} className=" ff-univanova-regular fz-14 c-pointer">
            {props.value}
          </a>
        </div>
      </div>
    </>
  );
}

export function CellItemWithImage(props) {
  return (
    <>
      <div
        className={`d-flex align-items-center col-${props.size === undefined ? "12" : props.size} col-lg-${
          props.sizeLg
        } ${(props.className !== undefined) & (props.className !== null) ? props.className : ""}`}
      >
        <img className="item-img me-2" width={64} height={64} src={props.image} alt="" />
        <div className="row m-0">
          <span className=" ff-univanova-bold fz-16 text-cl-black px-0">{props.title}</span>
          <span className=" ff-univanova-regular fz-12 c-pointer text-cl-black px-0">{props.value}</span>
        </div>
      </div>
    </>
  );
}

export function CellItemSwitch(props) {
  const CustomSwitch = withStyles({
    switchBase: {
      "&$checked": {
        color: "#4C9E70",
      },
      "&$checked + $track": {
        backgroundColor: "#C8F5DA",
      },
    },
    checked: {},
    track: {},
  })(Switch);

  return (
    <>
      <div
        onClick={props.onClick}
        className={`d-flex align-items-center justify-content-end justify-content-lg-start col-${
          props.size === undefined ? "12" : props.size
        } col-lg-${props.sizeLg} ${
          (props.className !== undefined) & (props.className !== null) ? props.className : ""
        }`}
      >
        <CustomSwitch checked={props.value} />
      </div>
    </>
  );
}
